import { render, staticRenderFns } from "./dialEditProduct.vue?vue&type=template&id=3644b226&"
import script from "./dialEditProduct.vue?vue&type=script&lang=js&"
export * from "./dialEditProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports